// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3y97b","inputDescription":"styles_inputDescription__3_nJi"};